<template>
    <div class="svg-container relative">
        <TerrenoJuegoComponent :direccion_campo="zona.direccion_campo"/>

        <SelectorAsientosComponent 
            :loading="loading" 
            :filas="filas"
            :print_align="zona.print_align"
            :front="true"
            @butacaSeleccionada="toggleSeleccion(...arguments, true, true)"    
        />

        <LeyendaButacasComponent/>
    </div>
</template>

<script>
import TerrenoJuegoComponent from "../../../common/Asientos/TerrenoJuegoComponent.vue";
import LeyendaButacasComponent from '@/components/common/Asientos/LeyendaButacasComponent.vue'
import SelectorAsientosComponent from "../../../common/Asientos/SelectorAsientosComponent.vue";
import { deviceDetect } from 'mobile-device-detect';
import comprobarButacas from "@/mixins/comprobarButacas";

export default {
    props: ['zona', 'asientos', 'forzar_adyacentes', 'can_click', 'stock'],
    mixins: [comprobarButacas],
    data() {
        return {
            loading: true,
            filas: null,
            datos_compradores: [],
            precios: null,
            n_entradas: 6
        }
    },
    created() {
        if(this.configuracion.hash_teatro == 'KNID9jzF7nw38XTOOUO6') {
            this.n_entradas = 2;
        }

        if(this.stock && this.stock < this.n_entradas) {
            this.n_entradas = this.stock;
        }
        this.datos_compradores = this.asientos;
        this.getZona(this.zona.id);
    },
    watch : {
        zona() {
            this.getZona(this.zona.id);
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        }
    },
    methods: {
        getZona(id) {
            this.loading = true;
            var params = null;
            if(this.$route.params.event_id != undefined && this.$route.params.sesion_id != undefined) {
                params = {
                    filters: {
                        zona_id: id,
                        conf: true,
                        evento_id: this.$route.params.event_id,
                        sesion_id: this.$route.params.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: id,
                    tid: this.configuracion.hash_teatro
                };
            } else {
                params = {
                    filters: {
                        zona_id: id,
                        conf: true,
                        tid: this.configuracion.hash_teatro
                    },
                    zona_id: id,
                    tid: this.configuracion.hash_teatro
                };
            }

            this.$store.dispatch(this.config.getVuexAlias('front.zonas.show'), params).then(res => {
                this.filas = res.data.data.configuracion;
                this.precios = res.data.data.precios;

                //si tengo row & seat los marco en la vista
                var row = this.$route.query.row;
                var seat = this.$route.query.seat;

                //si tengo dni y n_abonado_antiguo recupero su info y compruebo si el asiento es correcto
                var dni = this.$route.query.dni;
                var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;

                if(dni && n_abonado_antiguo) {
                    const params = {
                        filters: {
                            tid: this.configuracion.hash_teatro,
                            dni: dni,
                            n_abonado_antiguo: n_abonado_antiguo
                        },
                        tid: this.configuracion.hash_teatro,
                        dni: dni,
                        n_abonado_antiguo: n_abonado_antiguo
                    }

                    this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                        var comprador = {
                            nombre: res.data.abonado.name,
                            apellidos: res.data.abonado.surnames,
                            dni: res.data.abonado.dni,
                            fecha_nacimiento: res.data.abonado.fecha_nacimiento,
                            email: res.data.abonado.email,
                            telefono: res.data.abonado.telefono,
                            provincia: res.data.abonado.provincia,
                            localidad: res.data.abonado.localidad,
                            domicilio: res.data.abonado.domicilio,
                            n_abonado_antiguo: res.data.abonado.n_abonado_antiguo,
                            penista: res.data.abonado.penista,
                            importe_monedero: res.data.abonado.importe_monedero, 
                            asiento: null
                        };

                        var asiento = res.data.asiento;

                        this.datos_compradores.push(comprador);

                        if(row && seat) {
                            this.datos_compradores[0].asiento =  {
                                asiento: seat,
                                fila: row,
                                zona_id: asiento.region_id,
                                zona_name: asiento.region_name
                            };
                            this.toggleSeleccion(row, seat);
                            //si datos_compradores es 0 es porque no se ha seleccionado nada

                            this.actualizarDatos();
                            this.continuar();
                        }
                    }).catch(error => {
                        console.log(error);
                        this.loading = false;
                    });
                }

                this.loading = false;

                this.$emit('cargado');             
            });
        },
        toggleSeleccion : function(fila, asiento) {
            //Si tenemos dni y n_abonado_antiguo no dejamos seleccionar mas aientos
            var dni = this.$route.query.dni;
            var n_abonado_antiguo = this.$route.query.n_abonado_antiguo;

            for(var i in this.filas[fila]) {
                if(this.filas[fila][i].asiento == asiento && this.filas[fila][i].ocupado < 1 && this.can_click) {
                    if(this.filas[fila][i].seleccionado) {

                        //si el asiento estaba seleccionado, lo quito de datos_compradores
                        for(var j in this.datos_compradores) {
                            if(!dni && !n_abonado_antiguo) {
                                if(this.datos_compradores[j].asiento.fila == fila && this.datos_compradores[j].asiento.asiento == asiento) {
                                    this.datos_compradores.splice(j, 1);
                                    this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                                }
                            } else {
                                if(this.datos_compradores[0].asiento) {
                                    if(this.datos_compradores[j].asiento.fila == fila && this.datos_compradores[j].asiento.asiento == asiento) {
                                        this.datos_compradores[0].asiento = null;
                                        this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                                    }
                                }
                            }
                        }
                    } else {
                        if(this.datos_compradores.length < this.n_entradas) {
                            
                            var seleccionar = true;
                            
                            this.$emit('AsientosValidos' , seleccionar);

                            if(!dni && !n_abonado_antiguo) {
                                var data = {
                                    'asiento' : {
                                        fila : fila,
                                        asiento : this.filas[fila][i].asiento,
                                        zona_id : this.zona.id,
                                        zona_nombre : this.zona.name,
                                        lfp_id : this.filas[fila][i].lfp_id,
                                    },

                                    nombre : '',
                                    apellidos : '',
                                    dni : '',
                                    telefono : '',
                                    precios : this.precios,
                                    url_imprimir : null,
                                    es_nuevo : true,
                                    precio: this.precios[0]
                                }
                                //si tiene usuario relleno su informacion
                                if(this.filas[fila][i].usuario) {
                                    data.n_abonado_antiguo = this.filas[fila][i].usuario.n_abonado_antiguo;
                                    data.es_nuevo = false;
                                }
                                this.datos_compradores.push(data);
                                this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                            } else {
                                if(!this.datos_compradores[0].asiento) {
                                    this.datos_compradores[0].asiento = {
                                        fila : fila,
                                        asiento : this.filas[fila][i].asiento,
                                        zona_id : this.zona.id,
                                        zona_nombre : this.zona.name,
                                    };
                                    this.filas[fila][i].seleccionado = !this.filas[fila][i].seleccionado;
                                }
                            }
                        } else {
                            this.$toast.error('Ya no es posible adquirir más abonos, se ha superado el límite.');
                        }
                    }
                }
            }

            var valido = true;
            
            if(this.manager.comprobacion_butacas_abonos){
                valido =  this.comprobarButacas(this.filas);
            }

            this.$emit('AsientosValidos' , valido);

            this.actualizarDatos();
        },
        actualizarDatos() {
            this.$emit('actualizarDatos', this.datos_compradores, this.esConfiguracionAsientosValida());
        },
        continuar() {
            this.$emit('continuar');
        },
        esConfiguracionAsientosValida() {
            if(!this.forzar_adyacentes) {
                return true;
            }

            for(var fila in this.filas) {
                for(var i in this.filas[fila]) {
                    if(i == 0) continue;

                    let actual = this.filas[fila][i];
                    let anterior = this.filas[fila][i-1];
                    if((actual.seleccionado && !anterior.seleccionado && !anterior.ocupado) ||
                            (anterior.seleccionado && !actual.seleccionado && !actual.ocupado)) {
                        return false;
                    }
                }
            }
            return true;
        },
        scrollLeft() {
            this.$refs["butacasWrapper"].scrollBy(-this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
        },
        scrollRight() {
            this.$refs["butacasWrapper"].scrollBy(this.$refs["butacasWrapper"].parentElement.scrollWidth, 0)
        }
    },
    components: {
        TerrenoJuegoComponent, LeyendaButacasComponent, SelectorAsientosComponent
    }
}
</script>
